// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface ISystemGuideState {
  systemEntryGudie: boolean;
}

type ISetSystemEntryGuideAction = Action<'updateSystemEntryGudie'> & IPayload<boolean>;

export interface ISystemGuideModel {
  namespace: string;
  state: ISystemGuideState;
  effects: {};
  reducers: {
    updateSystemEntryGudie: Reducer<ISystemGuideState, ISetSystemEntryGuideAction>;
  };
}

export const SYSTEM_GUIDE_MODEL_NAMESPACE = 'dbg-model-system-guide';

const SystemGuideModel: ISystemGuideModel = {
  namespace: SYSTEM_GUIDE_MODEL_NAMESPACE,
  state: {
    systemEntryGudie: false,
  },
  effects: {},
  reducers: {
    updateSystemEntryGudie(state, action) {
      return { ...state, systemEntryGudie: !!action?.payload };
    },
  },
};

export default SystemGuideModel;
